import { Upload } from 'lucide-react'

interface DragDropOverlayProps {
  isDragActive: boolean
}

export function DragDropOverlay({ isDragActive }: DragDropOverlayProps) {
  if (!isDragActive) return null

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-[#141414]/90 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 rounded-2xl border-2 border-dashed border-[#f97316] px-16 py-12">
        <Upload className="size-12 text-[#f97316]" />
        <p className="text-lg font-medium text-gray-200">Drop your pitch deck here</p>
        <p className="text-sm text-muted-foreground">PDF files only</p>
      </div>
    </div>
  )
}
